/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Why_TailInputs */

const en_coaches_page_why_tail = /** @type {(inputs: Coaches_Page_Why_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Train for months.`)
};

const pl_coaches_page_why_tail = /** @type {(inputs: Coaches_Page_Why_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenujesz miesiącami.`)
};

/**
* | output |
* | --- |
* | "Train for months." |
*
* @param {Coaches_Page_Why_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_why_tail = /** @type {((inputs?: Coaches_Page_Why_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Why_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_why_tail(inputs)
	return en_coaches_page_why_tail(inputs)
});